// extracted by mini-css-extract-plugin
export var modal = "_50-0";